import { adminStyles as styles } from "../shared/adminStyles";

function AdminSectionHeader({ title, description }) {
  return (
    <header className="admin-workspace__section-header" style={styles.contentHeader}>
      <h2 style={styles.contentTitle}>{title}</h2>
      {description ? <p style={styles.contentDescription}>{description}</p> : null}
    </header>
  );
}

export default AdminSectionHeader;
